import { render, staticRenderFns } from "./IconContainer.vue?vue&type=template&id=04410c9d&scoped=true&"
import script from "./IconContainer.vue?vue&type=script&lang=js&"
export * from "./IconContainer.vue?vue&type=script&lang=js&"
import style0 from "./IconContainer.vue?vue&type=style&index=0&id=04410c9d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04410c9d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
